module.exports = __webpack_public_path__ + "static/img/user_avatar02.0ca5582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_avatar02.png
// module id = /eT2
// module chunks = 1